import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class ChannelsandoperationsService {
  baseUrlChannel = `${this.env.URL_API}/canal`;
  baseUrlOperation = `${this.env.URL_API}/operaciones`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient, private env: EnvService) { }

  createChannel(channel): Observable<any> {
    const url = `${this.baseUrlChannel}`;
    return this.http.post(url, channel);
  }

  getChannels(): Observable<any> {
    return this.http.get(`${this.baseUrlChannel}`);
  }

  getChannelsById(id): Observable<any> {
    return this.http.get(`${this.baseUrlChannel}/${id}`);
  }

  updateChannel(id, user): Observable<any> {
    const url = `${this.baseUrlChannel}/${id}`;
    return this.http
      .put(url, user, { headers: this.headers });
  }

  deleteChannel(id, idUser): Observable<any> {
    const url = `${this.baseUrlChannel}/${id}`;
    const httpOptions = {
      headers: this.headers,
      body: { id_usuarios_creador: idUser },
    };
    return this.http
      .delete(url, httpOptions);
  }

  createOperation(user): Observable<any> {
    const url = `${this.baseUrlOperation}`;
    return this.http.post(url, user);
  }

  getOperations() {
    return this.http.get(`${this.baseUrlOperation}`);
  }

  updateOperation(id, user): Observable<any> {
    const url = `${this.baseUrlOperation}/${id}`;
    return this.http
      .put(url, user, { headers: this.headers });
  }

  deleteOperation(id): Observable<any> {
    const url = `${this.baseUrlOperation}/${id}`;
    return this.http
      .delete(url, { headers: this.headers });
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }
}
